<template>
  <div class="welPage" >
    <div class="title-cover">
       <!--<img draggable="false" class="cover" src="../../assets/img/welpage/home.png">-->
        <div class="cover">
        </div>
        <div class="logoju"></div>
        <div class="logojus"></div>
       <img draggable="false" class="earth" src="../../assets/img/welpage/earth.png" alt="">
       <img draggable="false" class="title" src="../../assets/img/welpage/home_title.png" alt="">
       <img draggable="false" class="cai" src="../../assets/img/welpage/cai.png" alt="">
       <img draggable="false" class="dian" src="../../assets/img/welpage/dian.png" alt="">
      <!--<img class="cover-img" draggable="false" src="../../assets/img/welpage/background.png" alt="">-->
      <div class="addtext">
        <transition name="fade">
          <div v-show="!isEnter" :style="{opacity: btnIsShow ? 1 : 0}" class="btn" @click="runEnter">
            <div class="btn-show">
            </div>
            <!--<img draggable="false" class="btn-show" src="../../assets/img/welpage/button.png">-->
          </div>
        </transition>
        <p class="text">
          新华网出品|微景天下技术支持
        </p>
      </div>
      <div class="provide" v-if="false"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'welPage',
  props: {
    url: String,
    APPID: String,
    isEnter: Boolean
  },
  data () {
    return {
      couldClick: true,
      btnIsShow: false
    }
  },
  watch: {
    isEnter: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.couldClick = false
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.btnIsShow = true
    }, 3000)
  },
  methods: {
    runEnter () {
      if (this.couldClick) {
        this.$emit('runEnter', false)
        this.couldClick = false
      }
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }

  .welPage{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 999;
    opacity: 1;
    /*background: linear-gradient(174deg, #E8F2FF 0%, #4B6CB7 48%, #141E30 100%);*/
    & .provide{
      background: url("../../assets/img/pc/vizen.png") center center no-repeat;
      background-size: cover;
      height: rem(20);
      width: rem(260);
    }
    &.fade-enter{
      /*opacity: 0;*/
    }
    &.fade-enter-active{
      /*transition: opacity 3s;*/
    }
    &.fade-leave-to{
      opacity: 0;
    }
    &.fade-leave-active{
      transition: opacity 1.5s;
    }
  }
  .title-cover{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .cai{
      width: rem(695);
      height: rem(509);
      left: rem(48);
      top: rem(112);
      position: absolute;
      z-index: 1;
    }
    .dian{
      top: rem(0);
      left: rem(115);
      width: rem(407);
      height: rem(572);
      position: absolute;
      animation: dianfall 2s linear infinite;
    }
    .addtext{
      position: absolute;
      top: rem(307);
      right: rem(200);
      color: #FFFFFF;
      text-align: center;
      margin-top: rem(38);
      .text{
        font-size: rem(10);
        font-family: PingFang SC;
        font-weight: 400;
        color: #40898C;
        line-height: rem(54);
        letter-spacing:0.5em;
      }
      .btn{
        text-align: center;
        /*position: absolute;*/
        /*right: rem(306);*/
        /*top: rem(496);*/
        cursor: pointer;
        transform: scale3d(1,1,1);
        &.fade-enters{
          /*transform: scale3d(1.5,1.5,1);*/
        }
        &.fade-enter-active{
          animation: btnScale 2s;
        }
        &.fade-leave-to{
          opacity: 0;
        }
        &.fade-leave-active{
          transition: opacity 1.5s;
        }

        .btn-show,.btn-hover{
          /*width: rem(160);*/
          /*height: rem(40);*/

          font-size: rem(20);
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;

          /*background: url("../../assets/img/welpage/button.png") no-repeat 0 0;*/
          /*background-size: 100% 100%;*/
          /*&:hover{*/
          /*background: url("../../assets/img/welpage/button-hover.png") no-repeat 0 0;*/
          /*background-size: 100% 100%;*/
          /*}*/
        }
        .btn-show{
          display: flex;
          width: rem(140);
          height: rem(30);
          line-height: rem(50);
          overflow: hidden;
          margin: auto;
          margin-top: rem(76);
          background: url("../../assets/img/welpage/btn.png") no-repeat;
          background-size: 100% 100%;

        }
        .btn-hover{
          display: none;
        }
      }
      & p{
        font-size: 24px;
        text-align: center;
      }
      & span{
        margin-top: rem(23);
        text-align: center;
        display: inline-block;
        font-size: 20px;
      }
    }
    .logoju{
      width: rem(80);
      height: rem(80);
      position: absolute;
      right: rem(125);
      top: rem(30);
      background: url("../../assets/img/welpage/logo.png") center center no-repeat;
      background-size: contain;
    }
    .logojus{
      width: rem(148);
      height: rem(80);
      position: absolute;
      right: rem(240);
      top: rem(30);
      background: url("../../assets/img/welpage/sLogo.png") center center no-repeat;
      background-size: contain;
    }

    .cover {
      width: 100%;
      height: 100%;
      /*transition: all 1s;*/
      animation: bgpull 1.25s ease-in-out 1;
      animation-fill-mode: forwards;

      background: url("../../assets/img/welpage/home.png") center center no-repeat;
      background-size: cover;

    }
    .cover-img {
      width: 100vw;
      height: 100vh;
      display: block;
    }
    .earth{
      width: rem(690);
      height: rem(504);
      position: absolute;
      left: rem(0);
      top: rem(200);
      transition: transform 1s;
      z-index: 1;
    }

    .horse{
      width: rem(652);
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .title{
      width: rem(510);
      position: fixed;
      right: rem(130);
      /*top: rem(139);*/
      top: 0;
      animation: fade-in;/*动画名称*/
      animation-duration: 2s;/*动画持续时间*/
      animation: fall 1s linear forwards;
    }
    .logo{
      max-width: rem(211);
      max-height: rem(292);
      width: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }

    .provide{
      position: absolute;
      left: 50%;
      bottom: rem(12);
      font-size: rem(9);
      line-height: rem(10);
      color: #FFFFFF;
      letter-spacing: rem(2);
      text-align: center;
      text-indent: rem(20);
      transform: translateX(-50%);
      width: rem(258);
      height: rem(21);
    }
  }

  @keyframes btnScale
  {
    0% {
      transform: scale3d(1,1,1);
    }
    30% {
      transform: scale3d(1.5,1.5,1);
    }
    100% {
      transform: scale3d(1,1,1);
    }
  }

  @keyframes earthScale
  {
    0% {
      transform: scale3d(1,1,1);
    }
    30% {
      transform: scale3d(1.1,1.1,1);
    }
    100% {
      transform: scale3d(1,1,1);
    }
  }

  @keyframes bgpull
  {
   0%{
     /*-webkit-transform: scale(1.25, 1.25);*/
     /*transform: scale(1.25, 1.25);*/
     transform: scale3d(1,1,1);
   }
    100%{
      transform: scale3d(1.25,1.25,1);
    }
    /*100%{*/
      /*transform: scale3d(1,1,1);*/
    /*}*/
  }

  @keyframes fade-in {
    0% {opacity: 0;}/*初始状态 透明度为0*/
    50% {opacity: .6;}/*过渡状态 透明度为0*/
    80% {opacity: .8;}/*过渡状态 透明度为0*/
    100% {opacity: 1;}/*结束状态 透明度为1*/
  }

  @keyframes fall{
    0%{
      transform: translateY(0);
    }
    100%{
      transform: translateY(rem(139));
    }
  }
  @keyframes dianfall{
    0%{
      transform: translateY(0);
    }

    50%{
      transform: translateY(rem(20));
    }

    100%{
      transform: translateY(rem(0));
    }
  }


</style>
